module.exports = __webpack_public_path__ + "img/thumb.e062e4ad.svg";